import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

/* ------------------------------------------------------------------ */
/*  SuccessState — premium success card after signup / claim          */
/* ------------------------------------------------------------------ */

export default function SuccessState({
  title = "All set!",
  message = "Your account is created. We'll text you the moment a matching shift goes live.",
  primary = { label: "Browse open shifts", to: "/shifts/browse" },
  secondary,
  testid = "success-state",
}) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 240, damping: 22 }}
      className="rounded-3xl bg-white border border-slate-200 shadow-navy p-8 lg:p-12 text-center max-w-2xl mx-auto"
      data-testid={testid}
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.18, type: "spring", stiffness: 280, damping: 18 }}
        className="mx-auto w-16 h-16 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center"
      >
        <CheckCircle2 className="w-8 h-8 text-emerald-600" strokeWidth={2} />
      </motion.div>
      <h2 className="mt-6 font-display font-black text-3xl lg:text-4xl text-slate-900 text-balance">{title}</h2>
      <p className="mt-4 text-[15px] text-slate-600 leading-relaxed max-w-[48ch] mx-auto">{message}</p>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        {primary && (
          <Link
            to={primary.to}
            className="inline-flex items-center gap-1.5 px-5 py-3 rounded-full bg-trital-navy text-white text-[14px] font-semibold btn-lift hover:bg-trital-navy-deep"
            data-testid={`${testid}-primary`}
          >
            {primary.label} <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
          </Link>
        )}
        {secondary && (
          <Link
            to={secondary.to}
            className="inline-flex items-center gap-1.5 px-5 py-3 rounded-full border border-slate-300 text-slate-700 text-[14px] font-semibold hover:border-trital-navy hover:text-trital-navy hover:bg-slate-50"
            data-testid={`${testid}-secondary`}
          >
            {secondary.label}
          </Link>
        )}
      </div>
    </motion.div>
  );
}
